import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import {
  Box,
  Button,
  TextField,
  Typography,
  Snackbar,
  Alert,
  Chip,
  Popover,
  MenuItem,
  CircularProgress,
  IconButton,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";

import { formatDate, formatDateText, dateDifference } from "./CommonFunctions";
import Header from "./Header";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { AddRepair } from "./AddRepair";
import RepairModal from "./RepairModal";
import NewPost from "./AddImage";


const STATUS_COLORS = {
  'checked out and needs cleaning': "error",
  'scheduled': "info",
  // occupied: "error",
  'in progress':'info',
  'waiting for inspection': 'info',
  'inspected and ready to rent':'success',
  'needs maintainance': "info",
};
const STATUS_LABELS = {
    vacant_dirty:'checked out and needs cleaning',
    assigned:'scheduled',
    in_progress: 'in progress',
    inspection: 'waiting for inspection',
    vacant_clean:'inspected and ready to rent', 
    maintainance: "needs maintainance"

};
const statusOptions = Object.keys(STATUS_LABELS);

const StatusCell = ({ id, status }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [selectedStatus, setSelectedStatus] = React.useState(status);

  React.useEffect(() => {
  setSelectedStatus(status);
}, [status]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  const handleStatusChange = async (newStatus) => {
    setLoading(true);
    try {
      // await onUpdateStatus(id, newStatus);
      setSelectedStatus(newStatus);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  return (
    <>
      <Chip
        label={status}
        color={STATUS_COLORS[status]}
        onClick={handleClick}
        sx={{ cursor: "pointer", minWidth: 120 }}
        size="small"
      />
      {/* <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        {loading ? (
          <Box sx={{ m: 2, display: "flex", justifyContent: "center" }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          statusOptions.map((statusKey) => (
            <MenuItem
              key={statusKey}
              selected={statusKey === selectedStatus}
              onClick={() => handleStatusChange(statusKey)}
            >
              {STATUS_LABELS[statusKey]}
            </MenuItem>
          ))
        )}
      </Popover> */}
    </>
  );
};
const ActionsMenu = ({ row, onReportCleaning, onReportRepair,onReportImageUpload, handleCloseRepairModal }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleCleaning = () => {
    onReportCleaning(row);
    handleCloseMenu();
  };

  const handleRepair = () => {
    onReportRepair(row);
    handleCloseMenu();
  };

  const handleImageUpload = () => {
    onReportImageUpload(row);
    handleCloseMenu();
  };

  return (
    <>
      <IconButton onClick={handleOpenMenu} onTouchMove={handleCloseRepairModal}
             onMouseMove={handleCloseRepairModal}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
        <MenuItem onClick={handleCleaning}>Update the cleaning status</MenuItem>
        <MenuItem onClick={handleRepair} >Create a repair ticket</MenuItem>
        <MenuItem onClick={handleImageUpload} >Upload image</MenuItem>
        {/* <MenuItem >Add Comment</MenuItem> */}

      </Menu>
    </>
  );
};

const RoomAvailabilityReport = () => {
  const [checkin, setCheckin] = useState(formatDate(new Date()));
  const [checkout, setCheckout] = useState(formatDate(new Date(), 7));
  const [vacantRooms, setVacantRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [anchorEl, setAnchorEl] = useState(null);
  const [cleaningModal, setCleaningModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({})
  const [repairModal, setRepairModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);

  const [showRepairList, setShowRepairList] = useState(false);


  
  const url = process.env.REACT_APP_SERVER_URL;

  useEffect(() => {
    getVacantRoomsByDate(null, checkin, checkout);
  }, []);

  const getVacantRoomsByDate = async (e, searchStartDate, searchEndDate) => {
    if (e) e.preventDefault();
    if (!searchStartDate || !searchEndDate) {
      setSnackbar({ open: true, message: "Select both check-in and check-out dates", severity: "error" });
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${url}/vRoomsByDate`, {
        searchStartDate,
        searchEndDate,
      });
      console.log(response.data);
      const vacancyResponse = await axios.get(`${url}/vacancyTracking/status`);
      const repairsResponse = await axios.get(`${url}/repairs/active`);
      if(response  && vacancyResponse && repairsResponse){
        let roomdict={}
        // console.log("got all")
        console.log(response.data)
        for(let itr in response.data){
          const cr= response.data[itr];
          if(cr.id in roomdict){
            continue;
          }
          else{
            roomdict[cr.id] = {...cr, description:"", scheduledAt:null, assignedto: null, completedAt:null,status:null,
              vacancyTrackingId: null, cleaningId: null, repairCount: 0, repairs:[]};
          }
        }
        for(let itr in vacancyResponse.data){
          let cr = vacancyResponse.data[itr];
          if(cr.roomId in roomdict){
            roomdict[cr.roomId].vacancyTrackingId = cr.vacancyTrackingId;
            roomdict[cr.roomId].cleaningId = cr.cleaning_id;
            roomdict[cr.roomId]["assignedto"] = cr.assignedto;
            roomdict[cr.roomId].scheduledAt = cr.scheduledAt;
            roomdict[cr.roomId].description = cr.description;
            roomdict[cr.roomId].status = cr.status;
            roomdict[cr.roomId].actualCheckoutDate = cr.actualCheckoutDate;


            roomdict[cr.roomId]["completedAt"] = cr.completedAt;
          }
        }
        let repairsdict = {};

        for (let cr of repairsResponse.data) {
          if (repairsdict[cr.roomid]) {
            repairsdict[cr.roomid].repairs.push(cr);
          } else {
            repairsdict[cr.roomid] = { repairs: [cr] };
          }
        }

        // Step 2: Use keys of repairsdict to update roomdict
        for (let roomid in repairsdict) {
          if (roomdict[roomid]) {
            roomdict[roomid].repairCount = repairsdict[roomid].repairs.length;
            roomdict[roomid].repairs = repairsdict[roomid].repairs;
          }
        }
        console.log(roomdict)
        setVacantRooms(Object.values(roomdict))
      }
      // setVacantRooms(response.data);
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: "Failed to load rooms", severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (roomId, newStatus) => {
    try {
      await axios.patch(`${url}/rooms/${roomId}`, { current_status: newStatus });
      setVacantRooms((prevRooms) =>
        prevRooms.map((room) =>
          room.id === roomId ? { ...room, currentStatus: newStatus } : room
        )
      );
      // setSnackbar({ open: true, message: "Status updated successfully", severity: "success" });
    } catch (err) {
      console.error(err);
      // setSnackbar({ open: true, message: "Failed to update status", severity: "error" });
    }
  };
  const handleCleaningUpdate = async(updatedCleaning) =>{
    try{
      let cleaningJson ={
          roomid: updatedCleaning.id,
          assignedto: updatedCleaning.assignedto,
          scheduledAt: updatedCleaning.scheduledAt,
          completedAt: updatedCleaning.completedAt,
          status: updatedCleaning.status,
          description: updatedCleaning.description,
          vacancyTrackingId: updatedCleaning.vacancyTrackingId
        }
      if(updatedCleaning.cleaningId === null){
        console.log(updatedCleaning)
        const response = await axios.post(`${url}/cleaning`, cleaningJson);
        if(response && response.data){
          const res= await axios.patch(`${url}/rooms/${updatedCleaning.id}`,{
            current_status: updatedCleaning.status 
          })
          setVacantRooms((vacantRooms) => {
            return vacantRooms.map((room) => {
              if (room.id === updatedCleaning.id) {
                
                return {
                  ...room,
                  description: updatedCleaning.description,
                  assignedto: updatedCleaning.assignedto,
                  scheduledAt: updatedCleaning.scheduledAt,
                  completedAt: updatedCleaning.completedAt,
                  status: updatedCleaning.status,
                  cleaning_id: response.data.id,
                  current_status:updatedCleaning.status 
                };
              }
              return room;
            });
          });
        }
        
      }
      else{
        let tempJson= updatedCleaning;
        let roomId = updatedCleaning.id;
        tempJson.id = updatedCleaning.cleaningId;
        const cleaningRes = await axios.patch(`${url}/cleaning/${updatedCleaning.cleaningId}`, tempJson);
        const res= await axios.patch(`${url}/rooms/${roomId}`,{
            current_status: updatedCleaning.status
          })
          if(cleaningRes && cleaningRes.data && res && res.data){
            console.log("dghfghbg")
            setVacantRooms((vacantRooms) => {
                const res =  vacantRooms.map((room) => {
                  console.log(updatedCleaning.id)
                  if (room.id === roomId) {
                    // console.log(updatedCleaning.status === 'Completed')
                    return {
                      ...room,
                      description: updatedCleaning.description,
                      assignedto: updatedCleaning.assignedto,
                      scheduledAt: updatedCleaning.scheduledAt,
                      completedAt: updatedCleaning.completedAt,
                      status: updatedCleaning.status,
                      current_status: updatedCleaning.status 
                    };
                  }
                  return room;
                });
                console.log(res)
                return res;
              });
        }
        
      }

    }catch(error){
      console.log(error);
    }
  }
  const handleReportCleaning = (row) => {
  console.log("Cleaning report for", row);
  setCurrentRow(row)
  setCleaningModal(true);
  // open modal or dispatch logic here
  };

const handleReportRepair = (row) => {
  console.log("Repair report for", row);
  setCurrentRow(row);
  setRepairModal(true);
  // open modal or dispatch logic here
};

const handleImageUpload = (row) => {
  // console.log("Repair report for", row);
  setCurrentRow(row);
  setImageModal(true);
  // open modal or dispatch logic here
};

  const columns = [
    {
      field: "alias",
      headerName: "Room number",
      flex: 0.5,
      renderCell: (params) => (
        <Link
          to={`/search?checkin=${checkin}&checkout=${checkout}&roomNumber=${params.row.id}`}
          style={{ textDecoration: "none", color: "#1976d2" }}
        >
          {params.value}
        </Link>
      ),
      sortable: true,
    },
    {
      field: "actualCheckoutDate",
      headerName: "Last Checked Out",
      flex: 1.5,
      sortable: true,
      renderCell: (params) => {
        const date = params.row?.actualCheckoutDate;
        return (
          <>
          <b>{dateDifference(new Date(), date)}</b> days
          &nbsp;

            {date ? formatDateText(date) : "N/A"}{" "}
            {/* {date && (
              <>
                &nbsp;(<b>{dateDifference(new Date(), date)}</b> days)
              </>
            )} */}
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Readiness",
      flex: 2,
      sortable: true,
      renderCell: (params) => (
        <StatusCell id={params.row.id} 
        status={params.row.status}  
        />
      ),
    },
    {
      field: "assignedto",
      headerName: "Assigned to",
      flex: 1,
      sortable: true,
    },
    {
      field: "inspectedby",
      headerName: "Inspected by",
      flex: 1,
      sortable: true,
    },
    
    {
      field: "repairCount",
      headerName: "Open Repairs",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
       <><Link onClick={(e)=>{
        setCurrentRow(params.row);
       setShowRepairList(true);
       }}>{params.row.repairCount} 
       {/* repair{params.row.repairCount >1 ? "s" : null} */}
       </Link></>
      ),
    },
    {
      field: "description",
      headerName: "Comments",
      flex: 1.5,
      sortable: true,
    },
    
    // {
    //   field: "size",
    //   headerName: "Room Size",
    //   flex: 0.7,
    //   sortable: false,
    // },
    {
  field: "weeklyRate",
  headerName: "Weekly Rate",
  flex: 0.7,
  sortable: true,
  renderCell: (params) =>
    params.row?.weeklyRate !== undefined ? `$${params.row.weeklyRate}` : "N/A",
},
{
  field: "dailyRate",
  headerName: "Daily Rate",
  flex: 0.7,
  sortable: true,
  renderCell: (params) =>
    params.row?.dailyRate !== undefined ? `$${params.row.dailyRate}` : "N/A",
},
{
  field: "actions",
  headerName: "Actions",
  flex: 0.5,
  sortable: false,
  renderCell: (params) => (
    <ActionsMenu
      row={params.row}
      onReportCleaning={()=>handleReportCleaning(params.row)}
      onReportRepair={()=>handleReportRepair(params.row)}
      handleCloseRepairModal={()=>setRepairModal(false)}
      onReportImageUpload ={()=> handleImageUpload(params.row)}
    />
  ),
}


  ];

  return (
    <>
    <Header/>
      <Box sx={{ p: 2, mx:"3%" }}>
        {/* <Typography variant="h4" gutterBottom>
          Room Availability
        </Typography> */}
        <Box 
  component="form"
  onSubmit={(e) => getVacantRoomsByDate(e, checkin, checkout)}
  sx={{
    mx:15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
    width: "100%",
    maxWidth: 1000,  // controls overall container width
  }}
>
  <TextField
    label="Check-in Date"
    type="date"
    value={checkin}
    onChange={(e) => setCheckin(e.target.value)}
    InputLabelProps={{ shrink: true }}
    sx={{ flexGrow: 1, minWidth: 140 }}
  />
  <TextField
    label="Check-out Date"
    type="date"
    value={checkout}
    onChange={(e) => setCheckout(e.target.value)}
    InputLabelProps={{ shrink: true }}
    sx={{ flexGrow: 1, minWidth: 140 }}
  />
  <Typography sx={{ minWidth: 100, textAlign: "center" }}>
    <b>{dateDifference(checkin, checkout)} Days</b>
  </Typography>
  <Button variant="contained" type="submit" disabled={loading} sx={{ minWidth: 180 }}>
    {loading ? "Loading..." : "Search to get availability"}
  </Button>
</Box>


        {vacantRooms.length === 0 && !loading ? (
          <Typography color="error" variant="body1">
            There is no room available in the selected date range.
          </Typography>
        ) : (
          <Box sx={{ height: 450, width: "100%" }}>
            <DataGrid
              rows={vacantRooms}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              loading={loading}
              getRowId={(row) => row.id}
              disableSelectionOnClick
              autoHeight={false}
            />
          </Box>
        )}
      </Box>

      {/* <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar> */}
      {cleaningModal && <UpdateCleaningModal open={cleaningModal} 
      onClose={()=>setCleaningModal(false)} cleaning={currentRow}
      onSubmit={(updatedCleaning)=>handleCleaningUpdate(updatedCleaning)}/>}

      {repairModal && <AddRepair value={{roomNumber:currentRow.id}}/>}
      {showRepairList && <RepairModal open={showRepairList} onClose={()=>setShowRepairList(false)}
        data={currentRow.repairs} roomNumber={currentRow.id}/>}

      {imageModal && (
          <NewPost
            showDialog={imageModal}
            setShowDialog={setImageModal}
            cleaningId={currentRow.cleaningId}
          />
        )}
    </>
  );
};


const statuses = ['checked out and needs cleaning',
'scheduled',
'in progress',
'waiting for inspection',
'inspected and ready to rent', 
"needs maintainance"
];

const UpdateCleaningModal = ({ open, onClose, onSubmit, cleaning }) => {
  const [status, setStatus] = React.useState(cleaning.status || "");
  const [description, setDescription] = React.useState(cleaning.description || "");
  const [assignedto, setAssignedto] = useState(cleaning.assignedto || "");
  const [scheduledAt, setScheduledAt] = useState(cleaning.scheduledAt || formatDate(new Date()));
  const [completedAt, setCompletedAt] = useState(cleaning.completedAt || formatDate(new Date()));


  const handleSubmit = () => {
    const updatedCleaning = {
      ...cleaning,
      status,
      description,
      assignedto,
      scheduledAt,
      completedAt
    };
    onSubmit(updatedCleaning); // send to parent
    onClose();
  };
  console.log(status)

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Cleaning  - Room Number {cleaning.id}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={6} md={6}>
            <TextField
              select
              label="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              fullWidth
            >
              {statuses.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            
          </Grid>
          <Grid item xs={6} md={6}>
            <TextField
              type="date"
              label="Scheduled At"
              value={scheduledAt}

              onChange={(e) => setScheduledAt(e.target.value)}
              fullWidth
            >
            </TextField>
            
          </Grid>
          
          <Grid item xs={6} md={6}>
            <TextField
              label="Completed At"
              type="date"
              value={completedAt}
              fullWidth
              onChange={(e)=>setCompletedAt(e.target.value)}
            />
            </Grid>
            <Grid item xs={6} md={6}>
            <TextField
              label="Cleaned by"
              value={assignedto}
              fullWidth
              onChange={(e)=>setAssignedto(e.target.value)}
            />
            
            
          
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Comments / Description"
              multiline
              rows={4}
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};



export default RoomAvailabilityReport;
